VP = window.VP || {};

/*
 * Page Load Modifers
*/

(function( $ ) {
  VP.blackout = {
    bcheck: null,

    init: function() {
        var _this = this;
        // console.log("[initblackout]");

        _this.zeronum = VP.helpers.zeronum;

        if (!window._showblackout) {
          // console.log("no showblackout var");
          return;
        }
        _fadeInTime = 1500;
        _durationmins = 8;
        _durationsecs = 46;
        _pausefix = 15; // seconds

        _restart = false;
        _debug = VP.helpers.getQParams("debug") == "1";
        _debug3 = VP.helpers.getQParams("debug") == "3";

        if (_debug)  {
          _durationmins = 0;
          _durationsecs = 5;
        }
        else {
          // GET COOKIE VALS
          if (!_debug3) {
            if (!isNaN(parseInt(Cookies.get("durmins")))) {
              _durationmins = Cookies.get("durmins");
              _restart = true;
            }
            if (!isNaN(parseInt(Cookies.get("dursecs")))) {
              _durationsecs = Cookies.get("dursecs");
              _restart = true;
            }
          }
        }


        // console.log("startDate Date: " + startDateInt);
        // console.log("timeNow Date: " + timeNowInt);

        // ADD BLACKOUT
        _bodytext = "<div>#BlackLivesMatter</div><div>#GeorgeFloyd</div>";
        _html = "<div class='blackoutwrap'><div class='blackoutcontainer'><div class='countdown'>"+_this.zeronum(_durationmins)+":"+_this.zeronum(_durationsecs)+"</div><div class='blackouttext'>"+_bodytext+"</div></div></div>";
        $blackout = $(".blackout");
        if (!$blackout.length) {
          // console.log("[initblackout] NO BLACKOUT DIV");
          return;
        }
        $blackout.append(_html);
        $("body").addClass("bodyblackout");
        $(".blackoutwrap").fadeOut(0).fadeIn(500);

        if (_debug3) {
          return;
        }

        setTimeout(function() {
          // start timer
          if (!_restart && !_debug) {
            VP.helpers.firecustomGTMEvent("blackoutStarted");
            Cookies.set("bostarted","1");
          }

          endDate = moment(timeNowInt).add(_durationmins, 'minutes').add(_durationsecs, 'seconds');
          endDateInt = endDate.valueOf();
          // console.log("endDate Date: " + endDateInt);
          var eventTime= endDateInt; // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
          var currentTime = timeNowInt; // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
          var diffTime = eventTime - currentTime;
          var duration = moment.duration(diffTime, 'milliseconds');
          var interval = 1000;
          _this.bcheck = setInterval(function(){

            duration = moment.duration(duration - interval, 'milliseconds');

            // if paused on mobile
            timeNowCheck =  moment.tz("America/New_York");
            timeNowCheckInt = timeNowCheck.valueOf();
            durationcheck = moment.duration(endDateInt - timeNowCheckInt, 'milliseconds');
            durationdiff = Math.abs(duration - durationcheck)/1000;
            //console.log("[initblackout] duration check: " + durationdiff);
            if (durationdiff > _pausefix) {
              // console.log("[initblackout] Fix duration due to being paused, for more than: " + _pausefix);
              duration = durationcheck;
            }


            if (duration.asMilliseconds() > 0) {
               _text = _this.zeronum(duration.minutes()) + ":" + _this.zeronum(duration.seconds());
               Cookies.set("durmins",duration.minutes());
               Cookies.set("dursecs",duration.seconds());
            }
            else {
              if (!_debug) {
                VP.helpers.firecustomGTMEvent("blackoutCompleted");
              }
              Cookies.set("bocomplete","1");
              Cookies.set("durmins","0");
              Cookies.set("dursecs","0");
              _text = "00:00";

              clearInterval(VP.blackout.bcheck);
              if (window.location.pathname == "/") {
                $(".blackout").fadeOut(_fadeInTime);
                $("body").removeClass("bodyblackout");
              }
              else {
                window.location.href="/";
              }
            }
            //console.log(_text);
            $('.countdown').text(_text);

          }, interval);
        },_fadeInTime);

      }
    }

  })(jQuery);